import { createAction, props } from '@ngrx/store';
import {
  BusinessData,
  UpdateBusinessData,
  IDeleteGmbListingPayload,
  BusinessUnitManageResponse,
  BusinessUnitCompleteness,
} from '@app/api/models/api-models';

export enum BusinessActionTypes {
  GET_BUSINESS_UNITS = '[GetBusinessUnits] Get All Business Units',
  GET_BUSINESS_UNITS_SUCCESS = '[GetBusinessUnits] Get All Business Units Success',
  GET_BUSINESS_UNITS_FAILURE = '[GetBusinessUnits] Get All Business Units Failure',

  ERROR_LAYOUT_SHOW = '[Dashboard Error] show',
  ERROR_LAYOUT_HIDE = '[Dashboard Error] hide',

  DELETE_GMB_LISTING = '[DeleteGmbListing] Delete GoogleMyBusiness Listing',
  DELETE_GMB_LISTING_SUCCESS = '[DeleteGmbListing] Delete GoogleMyBusiness Listing Success',
  DELETE_GMB_LISTING_FAILURE = '[DeleteGmbListing] Delete Google My Business Listing Failure',

  REACTIVATE_GMB_LISTING_ATTEMPT = '[DashBoard] Reactivate GoogleMyBusiness Listing Attempt',
  REACTIVATE_GMB_LISTING_FAILURE = '[DashBoard] Reactivate GoogleMyBusiness Listing Failure',
  REACTIVATE_GMB_LISTING_SUCCESS = '[DashBoard] Reactivate GoogleMyBusiness Listing Success',

  GET_COMPLETENESS_ATTEMPT = '[Get Business Attempt] Get Completness Attempt',
  GET_COMPLETENESS_SUCCESS = '[Get Business Success] Get Completness Success',
  GET_COMPLETENESS_FAILURE = '[Get Business Failure] Get Completness Failure',

  VALIDATE_ADDRESS_ATTEMPT = '[Validate Address Attempt] Validate Address Attempt',
  VALIDATE_ADDRESS_FAILURE = '[Validate Address Failure] Validate Address Failure',
  VALIDATE_ADDRESS_SUCCESS = '[Validate Address Success] Validate Address Success',

  VALIDATE_PROFILE_ATTEMPT = '[Validate Profile Attempt] Validate Profile Attempt',
  VALIDATE_PROFILE_SUCCESS = '[Validate Profile Success] Validate Profile Success',
  VALIDATE_PROFILE_FAILURE = '[Validate Profile Failure] Validate Profile Failure',

  GET_ACTIONS_DASHBOARD = '[Dashboard Actions] Get Business Actions Dashboard',

  SET_SELECTED_BUSINESS = '[Set selected business] Set selected business after udpate',
}

export const getAllBusiness = createAction(BusinessActionTypes.GET_BUSINESS_UNITS, props<{ selectedEstablishmentId?: string }>());

export const getAllBusinessSuccess = createAction(
  BusinessActionTypes.GET_BUSINESS_UNITS_SUCCESS,
  props<{
    selectedEstablismentId: string;
    businessList: BusinessData[];
    businessUnitActionsRequest: any;
    upgradeActions: any;
  }>()
);

export const setSelectedBusinessUnit = createAction(BusinessActionTypes.SET_SELECTED_BUSINESS, props<{ businessData: BusinessData }>());

export const getAllBusinessFailure = createAction(BusinessActionTypes.GET_BUSINESS_UNITS_FAILURE, props<{ payload?: any }>());

export const reactivateGMBListingAttempt = createAction(
  BusinessActionTypes.REACTIVATE_GMB_LISTING_ATTEMPT,
  props<{ updateBusiness: UpdateBusinessData }>()
);

export const reactivateGMBListingSuccess = createAction(
  BusinessActionTypes.REACTIVATE_GMB_LISTING_SUCCESS,
  props<{ manageResponse: BusinessUnitManageResponse }>()
);

export const reactivateGMBListingFailure = createAction(BusinessActionTypes.REACTIVATE_GMB_LISTING_FAILURE, props<{ payload?: any }>());

export const errorLayoutShow = createAction(BusinessActionTypes.ERROR_LAYOUT_SHOW, props<{ error: any }>());

export const errorLayoutHide = createAction(BusinessActionTypes.ERROR_LAYOUT_HIDE, props<{ payload: any }>());

export const deleteGmbListing = createAction(BusinessActionTypes.DELETE_GMB_LISTING, props<{ payload: IDeleteGmbListingPayload }>());

export const deleteGmbListingSuccess = createAction(BusinessActionTypes.DELETE_GMB_LISTING_SUCCESS, props<{ payload?: any }>());

export const deleteGmbListingFailure = createAction(BusinessActionTypes.DELETE_GMB_LISTING_FAILURE, props<{ error: Error }>());

export const getCompletenessAttempt = createAction(BusinessActionTypes.GET_COMPLETENESS_ATTEMPT, props<{ establishmentId: string }>());

export const getCompletenessSuccess = createAction(
  BusinessActionTypes.GET_COMPLETENESS_SUCCESS,
  props<{ businessCompleteness: BusinessUnitCompleteness }>()
);

export const getCompletenessFailure = createAction(BusinessActionTypes.GET_COMPLETENESS_SUCCESS, props<{ payload?: any }>());

export const validateAddressAttempt = createAction(BusinessActionTypes.VALIDATE_ADDRESS_ATTEMPT, props<{ address?: any }>());

export const validateAddressFailure = createAction(BusinessActionTypes.VALIDATE_ADDRESS_FAILURE, props<{ errorCodes: string[] }>());

export const validateAddressSuccess = createAction(BusinessActionTypes.VALIDATE_ADDRESS_SUCCESS, props<{ errorCodes: string[] }>());

export const validateProfileAttempt = createAction(BusinessActionTypes.VALIDATE_PROFILE_ATTEMPT, props<{ businessData: BusinessData }>());

export const validateProfileSuccess = createAction(BusinessActionTypes.VALIDATE_PROFILE_SUCCESS, props<{ errorCodes: string[] }>());

export const validateProfileFailure = createAction(BusinessActionTypes.VALIDATE_PROFILE_FAILURE, props<{ errorCodes: string[] }>());

export const getActions = createAction(
  BusinessActionTypes.GET_ACTIONS_DASHBOARD,
  props<{
    selectedEstablismentId: string;
    businessList: BusinessData[];
    businessUnitActions;
    userActions;
    upgradeActions;
  }>()
);
